import { render, staticRenderFns } from "./SysMessageTemplateList.vue?vue&type=template&id=764f5a1c&scoped=true"
import script from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
export * from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
import style0 from "./SysMessageTemplateList.vue?vue&type=style&index=0&id=764f5a1c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f5a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764f5a1c')) {
      api.createRecord('764f5a1c', component.options)
    } else {
      api.reload('764f5a1c', component.options)
    }
    module.hot.accept("./SysMessageTemplateList.vue?vue&type=template&id=764f5a1c&scoped=true", function () {
      api.rerender('764f5a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/message/SysMessageTemplateList.vue"
export default component.exports